module.exports = __webpack_public_path__ + "img/extended.b485bd46.png";